export default {"src":"/_next/static/media/youtube-icon.063c2526.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};